import store from '@/store/store'

export function bridgeSetup() {
  return new Promise((resolve, reject) => {
    try {
      window.ibridge.isSetup(() => {
        console.log('ibridge has been ready! set window.ibridgeIsReady to true')
        window.ibridgeIsReady = true
        resolve()
      })
    } catch (err) {
      reject(err)
    }
  })
}

export function openWebView({ url = '' } = {}, handler = () => {}) {
  window.ibridge.callHandler('page.open', { url }, ( res ) => {
    console.log('page.open', res)
    if (res.code !== 0) {
      console.log('page.open失败', handler)
      handler()
    }
  })
}

export function closeWebView() {
  window.ibridge.callHandler('page.close')
}

/**
 * 劫持/归还 返回键 
 * @param {number} option 0: 归还，1：劫持
 */
export function setControlBack(option, handler = () => {}) {
  window.ibridge.callHandler('setting', {
    controlBack: option
  }, handler)
}

/**
 * 拉起app支付
 * 一直不reject或resolve有内存泄漏风险
 * @param {object} options 
 * @param {object} options._3rdParams 三方支付参数
 * @param {string} [options.payMethod] 支付方式
 * @param {string[]} [options.payMethods] 支付方式列表
 * @param {function} [handler] 回调函数
 */
export function sdkPay(options, handler = () => {}) {
  return new Promise((resolve, reject) => {
    window.ibridge.callHandler('pay.launch', options, (res) => {
      console.log('pay.launch', res)
      handler()
      resolve(res)
    })
  })
}

export function sendPayResult(data, handler = () => {}) {
  window.ibridge.callHandler('pay.result', data, (res) => {
    console.log('pay.result', res)
    handler()
  })
}
